import styled from 'styled-components'

export const StyledBalanceContainer = styled.div<{ isInIframe: boolean }>`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ isInIframe }) => isInIframe ? '0' : '22px'};
  margin-bottom: 7px;
  .amount {
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.primary};
  }
`
